export default {
  methods: {
    formatNumber(number) {
      var cleanedNumber = ('' + number).replace(/\D/g, '')
      var matched = cleanedNumber.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
      if (matched) {
        var intlCode = (matched[1] ? '1 ' : '')
        return [intlCode, '(', matched[2], ') ', matched[3], '-', matched[4]].join('')
      }

      return number
    },
  }
}
